import { STATES } from "../constants/states";

const stateSet = new Set<string>(STATES);

/**
 * Extracts the US state code from a SubmissionType enum value.
 *
 * Most submission types are prefixed with a 2-letter state code
 * (e.g. `KS_ANNUAL_REPORT` → `"KS"`, `CA_EVQ` → `"CA"`).
 *
 * Returns `null` for types that are not state-specific (e.g. `OTHER`,
 * `ANNUAL_REPORT`, `BIENNIAL_REPORT`, `WASTE_BIENNIAL`,
 * `HAZARDOUS_WASTE_NOTIFICATION`, `EXCEPTION_REPORT`).
 */
export function getStateForSubmissionType(submissionType: string): string | null {
  const underscoreIndex = submissionType.indexOf("_");
  if (underscoreIndex < 0) {
    return null;
  }

  const prefix = submissionType.substring(0, underscoreIndex);
  if (prefix.length === 2 && stateSet.has(prefix)) {
    return prefix;
  }

  return null;
}
